import React from 'react';

/**
 * Reusable Card Component with hover effects
 * @param {React.ReactNode} children - Card content
 * @param {string} className - Additional CSS classes
 * @param {boolean} hoverable - Enable hover effects (default: true)
 * @param {function} onClick - Optional click handler
 */
const Card = ({
  children,
  className = '',
  hoverable = true,
  onClick,
  ...props
}) => {
  // Base styles
  const baseStyles = 'bg-white rounded-lg shadow-md overflow-hidden';

  // Hover effect styles
  const hoverStyles = hoverable
    ? 'transition-all duration-300 hover:shadow-xl hover:scale-[1.02] hover:-translate-y-1'
    : '';

  // Clickable cursor
  const cursorStyle = onClick ? 'cursor-pointer' : '';

  const cardClasses = `${baseStyles} ${hoverStyles} ${cursorStyle} ${className}`;

  return (
    <div className={cardClasses} onClick={onClick} {...props}>
      {children}
    </div>
  );
};

export default Card;
